<ng-container *ngIf="!currentCropperImage">
  <div
    class="image-input {{ imageContainer }}"
    [class.no-border]="!!image"
    appDragDropFileUpload
    (fileDropped)="setImage($any($event))"
  >
    <!-- IMAGE = FALSE - Show add image box -->
    <div *ngIf="!image">
      <mat-icon svgIcon="add_photo_alternate"></mat-icon>
      <div class="input-image-placeholder" *ngIf="fromGalleryDialog">
        <p>{{ 'LOCATIONS.DROP_IMAGE' | translate }}</p>
        <button
          type="button"
          class="button-link"
          (click)="fileInputGallery.click()"
        >
          {{ 'LOCATIONS.BROWSE' | translate }}
        </button>

        <input
          [disabled]="isLoading"
          hidden
          type="file"
          accept="image/jpeg, image/png"
          (change)="setImage($any($event).target.files)"
          #fileInputGallery
          multiple
        />
      </div>

      <div class="input-image-placeholder" *ngIf="!fromGalleryDialog">
        <p>{{ 'LOCATIONS.DROP_IMAGE' | translate }}</p>
        <button type="button" class="button-link" (click)="fileInput.click()">
          {{ 'LOCATIONS.BROWSE' | translate }}
        </button>

        <input
          [disabled]="isLoading"
          hidden
          type="file"
          accept="image/jpeg, image/png"
          (change)="setImage($any($event).target.files)"
          #fileInput
        />
      </div>
      <span class="image-support">{{
        'LOCATIONS.IMAGE_SUPPORTS' | translate
      }}</span>
      <span class="image-support">{{ 'LOCATIONS.MIN_SIZE' | translate }}</span>
    </div>

    <!-- IMAGE = TRUE - Image preview -->
    <ng-container *ngIf="!!image">
      <div class="image-preview" (click)="fileInput.click()">
        <input
          [disabled]="isLoading"
          type="file"
          title="{{ 'LOCATIONS.CLICK_TO_CHANGE' | translate }}"
          accept="image/jpeg, image/png"
          (change)="setImage($any($event).target.files)"
          #fileInput
        />

        <img [src]="image" alt="{{ 'GENERAL.YOUR_PHOTO' | translate }}" />

        <div class="upload-loader" *ngIf="isLoading">
          <div class="loader-icon"></div>
          <p>
            {{
              isDeleting
                ? ('GENERAL.DELETING' | translate)
                : ('LOCATIONS.UPLOADING' | translate)
            }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="error" *ngIf="errorUpload">
    <p>{{ errorUpload }}</p>
  </div>

  <div class="actions">
    <button [disabled]="isLoading" class="secondary-button" mat-dialog-close>
      {{ 'LOCATIONS.CANCEL' | translate }}
    </button>

    <button
      [disabled]="isLoading"
      *ngIf="!!image"
      class="primary-outlined-button"
      (click)="removePhoto()"
    >
      {{ 'GENERAL.DELETE' | translate }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="currentCropperImage">
  <div class="cropper-wrapper">
    <image-cropper
      [aspectRatio]="16 / 9"
      [resizeToWidth]="2120"
      [onlyScaleDown]="true"
      [imageFile]="currentCropperImage"
      (imageCropped)="imageCropped($event)"
      format="png"
    ></image-cropper>

    <div class="upload-loader" *ngIf="isLoading">
      <div class="loader-icon"></div>
      <p>
        {{
          isDeleting
            ? ('GENERAL.DELETE' | translate)
            : ('LOCATIONS.UPLOADING' | translate)
        }}
      </p>
    </div>
  </div>

  <div class="cropper-desc">
    <p>
      {{ 'LOCATIONS.IMAGE_SIZE' | translate }}
      <span class="notranslate">{{
        this.imageMinSize / 1024 | numberTranslate
      }}</span
      >{{ 'LOCATIONS.KB' | translate }}.
    </p>
    <p
      [class.text-red]="imageMinSize > croppedImageSize.bytes"
      *ngIf="croppedImage?.blob?.size"
      class="cropper-current-img-size"
    >
      {{ 'LOCATIONS.CURRENT_IMAGE_SIZE' | translate }}:
      <span class="notranslate">{{
        croppedImageSize.kb | numberTranslate
      }}</span
      >{{ 'LOCATIONS.KB' | translate }}.
    </p>
  </div>

  <div class="actions">
    <button [disabled]="isLoading" class="secondary-button" mat-dialog-close>
      {{ 'LOCATIONS.CANCEL' | translate }}
    </button>

    <button
      class="primary-outlined-button"
      [disabled]="isCropperUploadButtonDisabled"
      (click)="uploadCroppedImage()"
    >
      {{ 'LOCATIONS.UPLOAD' | translate }}
    </button>
  </div>
</ng-container>
